import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { BonusFundsApiFrom } from '@api-gen/models/bonus-funds-api-from';


/**
 * Navigation bar in the header
 */
@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class NavbarComponent {
    /**
     * Flag authorized / not authorized
     */
    @Input() public loggedIn: boolean = false;
    /**
     * User balance value
     */
    @Input() public bonusFunds: BonusFundsApiFrom[];

    @ViewChild('menu') private menu: ElementRef<HTMLElement>;
    @ViewChild('button') private button: ElementRef<HTMLElement>;

    @Output() public updateBalances: EventEmitter<void> = new EventEmitter<void>();

    public navbarIsActive: boolean = false;

    public toggleNavbar(): void {
        this.navbarIsActive = !this.navbarIsActive;
    }

    @HostListener('document:click', ['$event'])
    public autoHideNavbar(event: MouseEvent): void {
        if (
            this.loggedIn &&
            this.navbarIsActive &&
            !this.button.nativeElement.contains(event.target as Node) &&
            (!this.menu.nativeElement.contains(event.target as Node)
                || (event.target as HTMLLinkElement).classList.contains('navbar-item-link'))
        ) {
            this.toggleNavbar();
        }
    }
}
